export default {
	SAVE_ERROR(state, payload) {
		state.error = payload
	},
	CLEAR_ERROR(state) {
		state.error = {}
	}
}
